import QicConnectPlugin from '@qicgroupdoha/qic-connect-ds';
import * as Sentry from '@sentry/vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createApp } from 'vue';

import Vue3Lottie from 'vue3-lottie';
import { queryClient } from '@/shared/api/query-client';

import providers from './app.providers';
import App from './App.vue';
import firebasePlugin from './plugins/firebase';

import http from './plugins/http';

import i18n from './plugins/i18n';
import pinia from './plugins/pinia';

import tanstackQuery from './plugins/tanstack-query';
import router from './router';

import '@qicgroupdoha/qic-connect-ds/style.css';
import '@qicgroupdoha/loyalty-components/style-slim.css';
import '@assets/styles/main.scss';

const app = createApp(App);

if (import.meta.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VUE_APP_SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [400, 599],
      }),
    ],
    tracesSampleRate: 0.5,

    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,

    environment: import.meta.env.VUE_APP_ENV,
  });
}

app.use(router);
app.use(pinia);
app.use(i18n);
app.use(http);
app.use(tanstackQuery);
app.use(firebasePlugin);
app.use(QicConnectPlugin, {});
app.use(Vue3Lottie);
app.use(VueQueryPlugin, { queryClient });

// important! providers should be used after plugins
app.use(providers);

console.log(
  `%capp version: ${__APP_VERSION__}`,
  'font-size: 1.5rem; color: #5927FF; background: white; border-radius: 16px; padding: 12px 20px;',
);

app.mount('#app');
